<script>
    import jQuery from "jquery";
    import {purchase} from "./gppy-payments";
    import {slide} from "svelte/transition";
    import {getCookie} from "./gppy-misc";

    let i18 = {
        "pl": {
            "Incorrect email.": "Niepoprawny email.",
            "Password must have at least 4 characters.": "Hasło musi mieć co najmniej 4&nbsp;znaki.",
            "To proceed terms must be accepted.": "Aby kontynuować wymagane jest zaakceptowanie regulaminu.",
            "Your purchase:": "Twój zakup:",
            "Your email:": "Twój email:",
            "Choose password:": "Wybierz hasło:",
            "Payment method:": "Forma płatności:",
//            "Bank transfer": "Przelew / BLIK",
//            "Credit card": "Karta kredytowa",
            "Address:": "Ulica i nr domu:",
            "Zip code:": "Kod pocztowy:",
            "City:": "Miasto:",
            "I accept": "Akceptuję",
            "terms.": "regulamin.",
            "I'd like to receive occasional emails with product updates and special offers": "Chcę otrzymywać okazjonalne maile o aktualizacjach produktów i specjalnych ofertach",
            "Buy now": "Kup teraz",
            "Your email address is required to process the transaction (we'll share it with PayPal). We do not process nor store credit/debit card data. More details can be found in our": "Twój adres email przetwarzamy w&nbsp;systemie w&nbsp;celu wystawienia licencji na program oraz do obsługi logowania. Po kliknięciu 'Kup teraz' przekażemy operatorowi płatności widoczne powyżej dane, w&nbsp;celu realizacji transakcji. Dane płatnicze (np. numery kart kredytowych) nie są przetwarzane w&nbsp;naszym systemie. Więcej -&nbsp;zobacz ",
            "Transaction is processed by PayPal. Having the PayPal account is not required, you can pay with a debit/credit card.": "Po kliknięciu 'Kup teraz' przekierujemy Cię na stronę operatora płatności (PayPro&nbsp;SA/Przelewy24.pl). Po zakończeniu transakcji zostaniesz przekierowany tu z&nbsp;powrotem a&nbsp;Twój program będzie gotowy do pobrania.",
            "Enter discount code": "Wpisz kod rabatowy",
            "If you have a discount code,": "Jeśli posiadasz kod rabatowy,",
            "click here": "kliknij tutaj",
            "Apply": "Zastosuj",
            "I need an invoice for this purchase": "Potrzebuję faktury za zakup"
        }
    }

    function t(message) {
        if (lang === "en") return message;
        if (lang === "pl") return i18['pl'][message] ? i18['pl'][message] : message;
    }

    let lang = document.documentElement.getAttribute("lang").toLowerCase() === "pl" ? "pl" : "en";

    export let email = null;
    export let product = null;
    export let productTable = null;

    let paymentProcessor = lang === "pl" ? "p24" : "paypal";

    let logged = false;
    let newAccountCreated = false;
    let password = null;
    let langDefaultCountry = {"en": "US", "pl": "PL"};
    let countryCode = langDefaultCountry[lang];

//    let p24address = null;
//    let p24zipcode = null;
//    let p24city = null;

    let termsAccepted = true;
    let termsMarketingAllowed = false;
    let autoRenew = true;
    let invoiceNeeded = false;
//    let paymentMethod = "transfer";

    let purchaseInProgress = false;
    let step = "form";
    let serverErrors = [];

    let discountCode = "";
    let discountFormShow = false;
    let codeErrors = [];
    let codeAccepted = false;

    $: selectedOriginalProductPrice = productTable[product].currencyPrefix + productTable[product].price.toFixed(2) + productTable[product].currencyPostfix;
    $: selectedProductPrice = productTable[product].discountedPrice ?
        productTable[product].currencyPrefix + productTable[product].discountedPrice.toFixed(2) + productTable[product].currencyPostfix :
        selectedOriginalProductPrice;
    $: selectedProductDescription =
        '<div class="productItem"><span class="productDesc">' + productTable[product].purchaseFormDesc + '</span> <span class="productPrice">(' + selectedProductPrice + ')</span></div>';

    $: allFieldsFilled = (logged) || (email && email.length && password && password.length)
    $: validEmail = !email || email.match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
    $: validPassword = !password || password.length > 3
    $: valid = allFieldsFilled && (logged || (validEmail && validPassword && termsAccepted))

    $: invalidEmailErr = validEmail ? "" : t("Incorrect email.")
    $: invalidPasswordErr = validPassword ? "" : t("Password must have at least 4 characters.")
    $: invalidTermsErr = termsAccepted ? "" : t("To proceed terms must be accepted.")

    $: form_errors = !allFieldsFilled ? [] : [...serverErrors, invalidEmailErr, invalidPasswordErr, invalidTermsErr].filter(e => e.length)

    export function showPurchaseForm() {
        logged = email.length;
        jQuery('#purchaseForm').on('hidden.bs.modal', () => onExit(this));

        jQuery('#purchaseForm input[type=text]').on('keyup', (e) => {
            if (e.which == 13 && valid) initPurchase();
        });
        //iterate over productTable and set discountedPrice to null
        for (let key in productTable) {
            productTable[key].discountedPrice = null;
        }

        //check get url parameter for code= and set discountCode
        let urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('code')) {
            discountCode = urlParams.get('code');
            checkDiscountCode();
        }

        jQuery('#purchaseForm').modal();
        jQuery('#purchaseForm').on('shown.bs.modal',function (){jQuery('#purchaseFormEmail').focus();});

        window.addEventListener("pageshow", () => {purchaseInProgress = false});
    }


    function initPurchase() {
        purchaseInProgress = true;
        Promise.resolve(jQuery.get('/fmg/emailExists', {'email': email})).then(emailChecked);
    }

    function emailChecked(res) {
        if (res.userExists) {
            if (paymentProcessor === "paypal")
                step = "confirmation";
            purchase(email, product, countryCode, autoRenew, discountCode, invoiceNeeded);
        } else
            registerAccount();
    }

    function registerAccount() {
        Promise.resolve(jQuery.post('/accounts/signup/', {
            'email': email,
            'password1': password,
            'marketing': termsMarketingAllowed ? 1 : 0
        })).then(function () {
                newAccountCreated = true;
                GPPY.initcsrf();
                if (paymentProcessor === "paypal")
                    step = "confirmation";
                purchase(email, product, countryCode, autoRenew, discountCode, invoiceNeeded);
            },
            showServerErrors);
    }

    function showServerErrors(res) {
        purchaseInProgress = false;
        step = "form";

        var errs = res.responseJSON.form.errors;
        var errspassword1 = res.responseJSON.form.fields.password1.errors;

        serverErrors = [...errs, ...errspassword1];
    }

    function checkDiscountCode() {
        codeErrors = [];
        let formData = new FormData();
        formData.append('code', discountCode);
        formData.append('product', product);
        fetch('/api/validateCode/', {
            method : 'POST',
            headers: {
                'Accept': 'application/json',
                "X-CSRFToken": getCookie("csrftoken")
            },
            body: formData}).
            then(async (response) => {
                if (response.ok) return response.json();
                else throw await response.json()}).
            then(applyDiscountCode).
            catch(showServerErrors)
    }

    function applyDiscountCode(res) {
        if (res.result === "error") {
            codeErrors = res.errors;
            return;
        }
        if (res.discount) {
            productTable[product].discountedPrice = res.price;
            codeAccepted = true;
        }
    }

    function onExit(form) {
        if (!logged && newAccountCreated)
            location.reload();
        else
            form.$destroy()
    }

</script>


<div id="purchaseForm" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span>
                </button>
                <h4 class="modal-title">{t("Your purchase:")}</h4>
                <div class="form-group purchaseFormProductDesc">
                    {@html selectedProductDescription}
                </div>
            </div>
            <div class="modal-body" transition:slide|local>
            {#if step==="form"}
                {#if !logged}
                    <div>
                        <div class="form-group-horizontal form-group-horizontal3">
                            <div class="form-group purchaseFormEmail">
                                <label for="purchaseFormEmail">{t("Your email:")}</label>
                                <input id="purchaseFormEmail" type="email" name="email" bind:value={email}/>
                            </div>
                            <div class="form-group purchaseFormPassword">
                                <label for="purchaseFormPassword">{t("Choose password:")}</label>
                                <input id="purchaseFormPassword" type="password" name="password" bind:value={password}/>
                            </div>
                        </div>
                    </div>
                {/if}
                <!--                {#if paymentProcessor === "p24"}
                    <div class="form-group-horizontal form-group-horizontal-p24paytype">
                        <div class="p24purchaseFormMethodRadio">
                            <label for="p24purchaseFormMethod">{t("Payment method:")}</label>
                            <label>
                                <input type="radio" name="p24purchaseFormMethod" bind:group={paymentMethod}
                                       value="transfer">
                                {t("Bank transfer")}
                            </label>
                            <label>
                                <input type="radio" name="p24purchaseFormMethod" bind:group={paymentMethod}
                                       value="cards">
                                {t("Credit card")}
                            </label>
                        </div>
                    </div>
                    {#if paymentMethod === "cards"}
                        <div>
                            <div class="form-group-horizontal form-group-horizontal5">
                                <div class="form-group purchaseFormP24Address">
                                    <label for="purchaseFormP24Address">{t("Address:")}</label>
                                    <input id="purchaseFormP24Address" type="text" bind:value={p24address}/>
                                </div>
                                <div class="form-group purchaseFormP24Zip">
                                    <label for="purchaseFormP24Zip">{t("Zip code:")}</label>
                                    <input id="purchaseFormP24Zip" type="text" bind:value={p24zipcode}/>
                                </div>
                                <div class="form-group purchaseFormP24City">
                                    <label for="purchaseFormP24City">{t("City:")}</label>
                                    <input id="purchaseFormP24City" type="text" bind:value={p24city}/>
                                </div>
                            </div>
                        </div>
                    {/if}
                {/if}-->
                {#if !valid || serverErrors.length}
                    <div class="form-group purchaseFormErrors has-error">
                        {#each form_errors as err}
                            <span class="help-block">{@html err}</span>
                        {/each}
                    </div>
                {/if}
                    <div class="purchaseArea">
                        <div class="form-group checkbox purchaseFormTerms" transition:slide|local>
                            {#if (paymentProcessor === "paypal")}
                            <label id="label_autorenew">
                                <input id="autorenew" type="checkbox" bind:checked={autoRenew}> Auto renew. You can cancel anytime
                            </label>
                            {/if}

                            {#if !logged}
                            <label id="label_purchaseFormTerms">
                                <input id="purchaseFormTerms" type="checkbox" bind:checked={termsAccepted}> {t("I accept")}
                                <a target="_blank" href="{lang==='pl'?'/pl':''}/legal">{t("terms.")}</a>
                            </label>
                            {#if lang==='en'}
                            <label id="label_purchaseFormMarketing">
                                <input id="purchaseFormMarketing" type="checkbox"
                                       bind:checked={termsMarketingAllowed}> {t("I\'d like to receive occasional emails with product updates and special offers")}
                            </label>
                            {/if}
                            {/if}
                            {#if lang==='pl'}
                            <label id="label_invoiceNeeded">
                                <input id="invoiceNeeded" type="checkbox"
                                       bind:checked={invoiceNeeded}> {t("I need an invoice for this purchase")}
                            </label>
                            {/if}
                        </div>
                        <a role="button" class="btn btn-primary btn-purchase purchaseFormButton" class:disabled={!valid || purchaseInProgress} on:click={initPurchase}>
                            <span class="total">
                            {#if selectedOriginalProductPrice !== selectedProductPrice}
                                <span class="crossed">{selectedOriginalProductPrice}</span>
                            {/if}
                            {selectedProductPrice}
                            </span>{t("Buy now")}
                        </a>
                    </div>

                <hr/>

                {#if !codeAccepted}
                    {#if discountFormShow}
                        <div class="form-group discountForm">
                            <input id="discountCode" type="text" bind:value={discountCode} placeholder="{t('Enter discount code')}"/>
                            <a role="button" class="btn btn-default"
                               class:disabled={purchaseInProgress} on:click={checkDiscountCode}>{t("Apply")}</a>
                        </div>
                        {#if codeErrors.length}
                            <div class="form-group codeFormErrors has-error">
                                {#each codeErrors as err}
                                    <span class="help-block">{@html err}</span>
                                {/each}
                            </div>
                        {/if}
                    {:else}
                    <p class="discountLink">
                        {t("If you have a discount code,")} <a on:click={() => {discountFormShow = true}}>{t("click here")}</a>
                    </p>
                    {/if}
                {/if}

                <div class="form-group purchaseFormText help-block3" transition:slide|local>
                    <div class="help-block">{@html t("Transaction is processed by PayPal. Having the PayPal account is not required, you can pay with a debit/credit card.")}
                    </div>
                    <div class="help-block purchaseFormPrivacy">{@html t("Your email address is required to process the transaction (we'll share it with PayPal). We do not process nor store credit/debit card data. More details can be found in our")}
                        <a target="_blank" href="/legal">{t("terms.")}</a>
                    </div>
                </div>
            {/if}
           {#if paymentProcessor === "paypal"}
                <div id="paypal-button-container"></div>
           {/if}
            </div>

        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div><!-- /.modal -->